import { render, staticRenderFns } from "./insuredDetails.vue?vue&type=template&id=efdf985e&"
import script from "./insuredDetails.vue?vue&type=script&lang=js&"
export * from "./insuredDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports